<!-- Floating chat button -->
<button
  class="kb-chatbot-trigger"
  (click)="toggle()"
  [class.open]="isOpen"
  [attr.aria-label]="isOpen ? 'Close AI Assistant' : 'Open AI Assistant'"
>
  <span *ngIf="!isOpen" class="trigger-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  </span>
  <span *ngIf="isOpen" class="trigger-close">&times;</span>
</button>

<!-- Chat panel -->
<div class="kb-chatbot-panel" *ngIf="isOpen">
  <div class="kb-chatbot-header">
    <span class="kb-chatbot-title">Dashboardly AI Assistant</span>
    <div class="kb-chatbot-header-actions">
      <button class="kb-chatbot-clear" (click)="clearChat()" title="Clear chat history" aria-label="Clear chat history">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="3 6 5 6 21 6" />
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
        </svg>
      </button>
      <button class="kb-chatbot-close" (click)="toggle()">&times;</button>
    </div>
  </div>

  <div class="kb-chatbot-messages" #messagesContainer>
    <div
      *ngFor="let msg of messages"
      class="kb-chatbot-message"
      [class.user]="msg.role === 'user'"
      [class.assistant]="msg.role === 'assistant'"
      [class.error-message]="msg.isError"
    >
      <!-- Bot messages rendered as markdown -->
      <div
        *ngIf="msg.role === 'assistant'"
        class="kb-chatbot-message-content bot-message"
        [innerHTML]="renderMarkdown(msg.content)"
      ></div>

      <!-- User messages rendered as plain text -->
      <div *ngIf="msg.role === 'user'" class="kb-chatbot-message-content">{{ msg.content }}</div>

      <!-- Confidence indicator -->
      <div
        *ngIf="msg.role === 'assistant' && msg.confidence !== undefined && msg.confidence < 0.8 && !msg.isError"
        class="kb-chatbot-confidence"
        [class.low]="msg.confidence < 0.5"
      >
        {{ msg.confidence < 0.5 ? "I'm not very sure about this" : 'Approximate answer' }}
      </div>

      <!-- Sources -->
      <div *ngIf="msg.sources && msg.sources.length > 0" class="kb-chatbot-sources">
        <span class="kb-chatbot-sources-label">Sources:</span>
        <span *ngFor="let src of msg.sources" class="kb-chatbot-source-tag">{{ src.title }}</span>
      </div>

      <!-- Follow-up suggestions -->
      <div *ngIf="msg.followUp && msg.followUp.length > 0" class="kb-chatbot-followups">
        <button *ngFor="let fq of msg.followUp" class="kb-chatbot-followup-btn" (click)="askFollowUp(fq)">
          {{ fq }}
        </button>
      </div>
    </div>

    <!-- Loading indicator -->
    <div *ngIf="isLoading" class="kb-chatbot-message assistant">
      <div class="kb-chatbot-message-content kb-chatbot-typing">Thinking...</div>
    </div>
  </div>

  <div class="kb-chatbot-input">
    <textarea
      #inputArea
      [(ngModel)]="question"
      (keydown.enter)="onEnterKey($event)"
      (input)="autoGrow($event)"
      placeholder="Ask a question..."
      aria-label="Type your question for the AI assistant"
      [disabled]="isLoading"
      rows="1"
    ></textarea>
    <button (click)="ask()" [disabled]="isLoading || !question.trim()">Send</button>
  </div>
</div>
